import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store/index";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);

import VueNumberInput from '@chenfengyuan/vue-number-input';
Vue.use(VueNumberInput)

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

import Notifications from 'vue-notification';
Vue.use(Notifications);

import Moment from 'vue-moment';
Vue.use(Moment);

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas)
library.add(far)
Vue.component('font-awesome-icon', FontAwesomeIcon)

import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import { required, email, min } from 'vee-validate/dist/rules';

extend('email', email)
extend('min', min)
extend('required', {
  ...required,
  message: 'can\'t be blank'
})
extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: 'password confirmation does not match'
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.$cookies.config('7d')

Vue.config.productionTip = false;

new Vue({
  router,
  store: store,
  render: h => h(App)
}).$mount("#app");
